import { jsx as _jsx } from "react/jsx-runtime";
import { StyledTable } from './StyledTableComponents';
export const DefaultTableComponent = ({
  children,
  requiredTableProps
}) => {
  return /*#__PURE__*/_jsx(StyledTable // Overrides contextual styles when rendered in a card
  , Object.assign({
    bordered: true,
    condensed: true,
    flush: true,
    responsive: false
  }, requiredTableProps, {
    children: children
  }));
};